const stylesMobile = {
  heroContainerMobile: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    height: "clamp(40rem, 90vh, 50rem)",
    textAlign: "center",
    position: "relative",
    // backgroundColor: "green",
    top: "clamp(5.4rem, 9vh, 12rem)",
    bottom: 0,
  },  

  backgroundMobile: {
    position: "absolute",
    top: "clamp(3rem, 12vh, 8rem)",
    width: "clamp(28rem, 10vh, 28rem)",
    height: "clamp(22rem, 9vh, 22rem)",
    objectFit: "cover",
    opacity: 0.8,
    zIndex: 1,
  },

  contentContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    zIndex: 4,
    // backgroundColor: "blue",
  },

  logo: {
    width: "clamp(2rem, 12vw, 3.6rem)",
    height: "auto",
    marginBottom: "clamp(3.2rem, 6vw, 3rem)", // 🔹 Mantém espaçamento dinâmico
    marginTop: "4vh",
    // backgroundColor: 'green',
  },

  heading: {
    fontSize: "clamp(1rem, 8.4vw, 2.4rem)",
    fontWeight: 200,
    color: "#FFF",
    textAlign: "center",
    marginBottom: "clamp(1.5rem, 3vw, 1.8rem)",
    paddingLeft: "clamp(1rem, 9vh, 3.8rem)",
    paddingRight: "clamp(1rem, 9vh, 3.8rem)",
  },

  subheading: {
    fontSize: "clamp(1rem, 4vw, 2rem)",
    color: "rgba(217, 217, 217, 0.5)",
    paddingLeft: "clamp(1rem, 9vh, 4.8rem)",
    paddingRight: "clamp(1rem, 9vh, 4.8rem)",
  },

  subheadingHighlight: {
    color: "rgba(217, 217, 217, 0.9)",
  },

  heroArt: {
    marginTop: "clamp(6rem, 25vw, 22rem)", // 🔹 Posiciona a Hero Art mais abaixo
    maxWidth: "100%",
    height: "auto",
    opacity: 0.9,
    transition: "transform 0.3s ease, background-color 0.3s ease",
  },
  // 🔹 Cartões de fundo para o mobile
  cardsContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "100%",
    top: "clamp(14rem, 32vh, 18rem)"
  },

  cardGradient: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    zIndex: 1,
  },

  card1Placeholder: {
    position: "absolute",
    // top: "5%",
    left: "50%",
    width: "clamp(6rem, 96vw, 24rem)",
    height: "clamp(4rem, 46vw, 16rem)",
    // backgroundColor: "#222",
    border: "0.8px solid rgba(200, 200, 200, 0.2)",
    borderRadius: "clamp(15px, 30px, 40px)",
    // opacity: 0.3,
    zIndex: 2,
    transform: "translateX(-36%) rotate(-2.67deg)",
    marginTop: "clamp(-4rem, -6vw, -8rem)",
    
  },

  card2Placeholder: {
    position: "absolute",
    top: "55%",
    left: "50%",
    width: "clamp(6rem, 96vw, 24rem)",
    height: "clamp(6rem, 56vw, 16rem)",
    // backgroundColor: "#333",
    border: "0.8px solid rgba(200, 200, 200, 0.2)",
    borderRadius: "clamp(15px, 30px, 40px)",
    // opacity: 0.3,
    zIndex: 3,
    transform: "translateX(-78%) rotate(2.27deg)",
    marginTop: "clamp(0.3rem, 0.6vw, 0.65rem)",
  },

  animatedImage: {
    position: "absolute",
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    pointerEvents: "none",
    zIndex: 5,
    opacity: 0.3,
  },  
  
  cardBlur: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    borderRadius: "clamp(15px, 30px, 40px)",
    backdropFilter: 'blur(28px)',// <-- sempre inicia em 100px
    zIndex: 4,
  },
};

export default stylesMobile;
